/**
 * Switches the sign-in screens between Arabic and English before anyone has
 * signed in. It sets the device's language, an explicit choice that carries
 * into the app after sign-in unless the person has saved a locale of their
 * own in Profile, which wins. The workspace's locale never picks it.
 *
 * Each language is named in itself ("العربية", "English"), the convention
 * for a language switch, with `lang` so a screen reader pronounces it right.
 */
import { i18n, useTranslation, type Language } from "@/lib/i18n";
import { localeForLanguage } from "@/lib/i18n/locale";

const LANGUAGE_NAMES: Record<Language, string> = {
  en: "English",
  ar: "العربية",
};

export function LanguageSwitch() {
  const { i18n: active } = useTranslation();
  const other: Language = active.language === "ar" ? "en" : "ar";
  return (
    <button
      type="button"
      className="atlas-btn atlas-btn--sm atlas-btn--ghost"
      lang={other}
      dir={other === "ar" ? "rtl" : "ltr"}
      onClick={() => i18n.changeLanguage(localeForLanguage(other))}
    >
      {LANGUAGE_NAMES[other]}
    </button>
  );
}
